import {v4 as uuidv4} from 'uuid';
import {ContentDetailVo} from '../../common/shared/api/nicolas/vo/ContentDetailVo.interface';
import {ContentDetail} from '../generated/types';
import {createAgeGrade} from './AgeGrade';

export function createContentDetail({
  age_grade,
  publisher_name,
  publisher_operation_label,
  retail_price,
  category_list,
  rank,
}: ContentDetailVo): ContentDetail {
  return {
    id: uuidv4(),
    ageGrade: createAgeGrade(age_grade),
    publisherName: [publisher_name, publisher_operation_label]
      .filter(i => !!i)
      .join(' | '),
    retailPrice: retail_price,
    category: category_list.join(' | '),
    rank,
  };
}
